export const SET_AUTH_USER = 'SET_AUTH_USER';

export const GET_CURRENT_FOLDER = 'GET_CURRENT_FOLDER';
export const RESET_CURRENT_FOLDER = 'RESET_CURRENT_FOLDER';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const RESET_SEARCH_VALUE = 'RESET_SEARCH_VALUE';
export const RESET_COGS = 'RESET_COGS';
export const GET_COGS_FROM_ALGOLIA = 'GET_COGS_FROM_ALGOLIA';
export const DELETE_COG = 'DELETE_COG';
